import { useState } from "react";
import { useTranslation } from "react-i18next";

import type { Controllable } from "@lib/store";
import { Icon } from "@atoms";

import { ControlOptions } from "./ControlOptions";

// Opens to show the control's options
export const ControlItem = ({ control, nodeId }: { control: Controllable; nodeId: string }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const isTemperature = control.type === "temperature";

  return (
    <div className="flex flex-col gap-2 bg-beige-200 px-6 py-5">
      <button
        type="button"
        aria-expanded={isExpanded}
        className="flex items-center gap-4 text-left"
        onClick={() => setIsExpanded(!isExpanded)}>
        <Icon
          icon={isTemperature ? "temperature" : "blindsNew"}
          size="24px"
        />
        <span className="flex flex-1 flex-col">
          <span className="text-mapiq-black-500">
            {isTemperature ? t("controls:Temperature") : t("controls:Blinds")}
          </span>
          <span>{control.displayName}</span>
        </span>
        <Icon
          icon={isExpanded ? "caretUp" : "caretDown"}
          size="24px"
        />
      </button>

      {isExpanded && (
        <ControlOptions
          control={control}
          nodeId={nodeId}
        />
      )}
    </div>
  );
};
